import { NodeEnvironment } from './constants';

export const isProdNodeEnv = (): boolean => process.env.NODE_ENV === NodeEnvironment.PRODUCTION;
export const isDevNodeEnv = (): boolean => process.env.NODE_ENV === NodeEnvironment.DEVELOPMENT;
export const isTestNodeEnv = (): boolean => process.env.NODE_ENV === NodeEnvironment.TEST;
